import { SubscribeQuery } from '@/queries';

const getAll = (retailerId: string): SubscribeQuery => ({
  className: 'FeatureFlag',
  where: {
    $or: [
      {
        status: 'READY',
        retailer: {
          $exists: false,
        },
      },
      {
        status: 'BETA',
        retailer: {
          $exists: false,
        },
      },
      {
        retailer: {
          __type: 'Pointer',
          className: 'Retailer',
          objectId: retailerId,
        },
      },
    ],
  },
});

const FeatureFlagQueries = {
  getAll,
};

export default FeatureFlagQueries;
